// @ts-nocheck
import React, { useCallback } from 'react';
import { ToggleButtonGroup, ToggleButton, Tooltip } from '@mui/material';
import { ReactComponent as TextFieldsIcon } from '../../../../../assets/Icons/lucideIcons/form.svg';
import { ReactComponent as CalendarTodayIcon } from '../../../../../assets/Icons/lucideIcons/calendar.svg';
import { ReactComponent as Filter1Icon } from '../../../../../assets/Icons/lucideIcons/arrow-up-0-1.svg';
import { ReactComponent as ShowChartIcon } from '../../../../../assets/Icons/lucideIcons/chart-no-axes-combined.svg';

import {
  useTableDispatch,
  useTableState,
} from '../../../context/TableSchemaBuilderContext';
import { DATA_TYPES } from './Fields/Fields';
import GroupWrapper from '../Wrappers/GroupWrapper';

const CellDataTypeGroup = () => {
  const { ui, schema } = useTableState();
  const dispatch = useTableDispatch();

  const handleDataTypeChange = useCallback(
    (_event, newType) => {
      if (!newType || !ui.currentCell) {
        return;
      }

      dispatch({
        type: 'UPDATE_CELL_DATA_TYPE',
        payload: {
          cellId: ui?.currentCell,
          dataType: newType,
        },
      });
    },
    [dispatch, ui?.currentCell]
  );

  const currentDataType =
    schema?.cells?.[ui.currentCell]?.dataType || DATA_TYPES.TEXT;

  return (
    <GroupWrapper label="Data Type">
      <ToggleButtonGroup
        size="small"
        exclusive
        value={currentDataType}
        onChange={handleDataTypeChange}
        sx={{ mx: 1 }}
      >
        <Tooltip title="Text">
          <ToggleButton value={DATA_TYPES.TEXT}>
            <TextFieldsIcon width={18} height={18} />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Date">
          <ToggleButton value={DATA_TYPES.DATE}>
            <CalendarTodayIcon width={18} height={18} />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Integer">
          <ToggleButton value={DATA_TYPES.INTEGER}>
            <Filter1Icon width={18} height={18} />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Float">
          <ToggleButton value={DATA_TYPES.FLOAT}>
            <ShowChartIcon width={18} height={18} />
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </GroupWrapper>
  );
};

export default CellDataTypeGroup;
